import { render, staticRenderFns } from "./RoomJoinRules.vue?vue&type=template&id=0256edd3&"
import script from "./RoomJoinRules.vue?vue&type=script&lang=js&"
export * from "./RoomJoinRules.vue?vue&type=script&lang=js&"
import style0 from "./RoomJoinRules.vue?vue&type=style&index=0&id=0256edd3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports